import React, { useState } from 'react'
import {
  Button,
  TextField,
  Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle
} from '@mui/material'
import LocalizationProvider from '@mui/lab/LocalizationProvider'
import DateAdapter from '@mui/lab/AdapterDateFns'
import DatePicker from '@mui/lab/DatePicker'

const CreateFolderForm = (props) => {
  const [date, setDate] = useState(null)
  const [place, setPlace] = useState('')
  const [folderName, setFolderName] = useState('')

  return (
    <div>
      <Dialog open={props.open} onClose={props.onClose}>

        <DialogTitle>Create Folder</DialogTitle>

        <DialogContent>
          <DialogContentText>
          </DialogContentText>

          {/* <LocalizationProvider dateAdapter={DateAdapter}>
            <DatePicker
              label="Date"
              value={date}
              onChange={(newValue) => {
                setDate(newValue)
              }}
              renderInput={(params) => {
                return <TextField margin='dense' fullWidth variant='standard' {...params} />
              }}
              dateFormat="yyyy-MM-dd"
            />
          </LocalizationProvider>

          <TextField
            margin="dense"
            id="name"
            label="Place"
            type='text'
            fullWidth
            variant="standard"
            onChange={(event) => {
              setPlace(event.target.value)
            }}
          /> */}


          <TextField
            margin="dense"
            id="name"
            label="Folder Name"
            type='text'
            fullWidth
            variant="standard"
            onChange={(event) => {
              setFolderName(event.target.value)
            }}
          />

        </DialogContent>

        <DialogActions>
          <Button onClick={props.onClose}>
            Cancel
          </Button>
          <Button onClick={() => {
            let _folderName = folderName
            props.onCreate(_folderName)
          }}>
            Create
          </Button>
        </DialogActions>

      </Dialog>
    </div>
  )
}

export default CreateFolderForm
